module.exports = __webpack_public_path__ + "static/media/yellowSmiley.a869e363.png";